import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { U2000_AuthenticationService } from '../../../../U2000_core/U2000_services/U2000_authentication.service';

@Component({
    selector: '[u2000-reportmenu]',
    templateUrl: 'U2000_reportmenu.component.html',
    styleUrls: ['U2000_reportmenu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2000_ReportMenuComponent {
    constructor(
        public authService: U2000_AuthenticationService,
        public router: Router,
    ) {}

    showReports() {
        this.router.navigate(['U2024']);
    }
}
